import { render, staticRenderFns } from "./header3.vue?vue&type=template&id=558fbbc0&scoped=true"
import script from "./header3.vue?vue&type=script&lang=js"
export * from "./header3.vue?vue&type=script&lang=js"
import style0 from "./header3.vue?vue&type=style&index=0&id=558fbbc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558fbbc0",
  null
  
)

export default component.exports